'use client'

import { useEffect, useRef } from 'react'
import Lottie from 'lottie-react'
import type { LottieRefCurrentProps } from 'lottie-react'
import { useReducedMotion } from '@mantine/hooks'
import { Box } from '@mantine/core'

import { emailLottieEltrustData } from '@lib/animations/email-lottie-eltrust'

import classes from './email-sent-lottie.module.css'

type EmailSentLottieProps = {
    ariaLabel: string
    variant?: 'default' | 'compact'
    loop?: boolean
}

export default function EmailSentLottie({ ariaLabel, variant = 'default', loop }: EmailSentLottieProps) {
    const prefersReducedMotion = useReducedMotion()
    const lottieRef = useRef<LottieRefCurrentProps | null>(null)
    const pause = prefersReducedMotion === true
    const shouldLoop = loop ?? variant === 'default'

    useEffect(() => {
        if (!pause) return
        const id = requestAnimationFrame(() => {
            lottieRef.current?.goToAndStop(42, true)
        })
        return () => cancelAnimationFrame(id)
    }, [pause])

    const wrapClass = variant === 'compact' ? classes.wrapCompact : classes.wrap

    return (
        <Box className={wrapClass} aria-label={ariaLabel}>
            <Lottie
                lottieRef={lottieRef}
                animationData={emailLottieEltrustData}
                loop={!pause && shouldLoop}
                autoplay={!pause}
                className={classes.lottie}
                rendererSettings={{ preserveAspectRatio: 'xMidYMid meet' }}
                onDOMLoaded={() => {
                    if (pause) lottieRef.current?.goToAndStop(42, true)
                }}
            />
        </Box>
    )
}
